module.exports = __webpack_public_path__ + "img/bridge5.00426b52.png";